"use client";

import AdmissionsPrototype from "@/app/admissions/components/AdmissionsPrototype";
import { TourButton } from "@/components/tours/TourButton";
import { useAutoTour } from "@/components/tours/useAutoTour";
import { TOURS } from "@/components/tours/catalog";

export function AdmissionsPanel() {
    const { replay: replayTour } = useAutoTour("staff.admissions", TOURS["staff.admissions"]);
    return (
        <div className="space-y-2">
            <div className="flex items-center gap-3 mb-1">
                <span className="text-xs font-bold uppercase tracking-widest text-[#007a8a] bg-[#007a8a]/10 px-2 py-0.5 rounded">
                    Prototype v1.0
                </span>
                <span className="text-xs text-gray-400">Demo mode — data resets on page refresh</span>
                <span className="ml-auto"><TourButton onClick={replayTour} /></span>
            </div>
            <div id="admissions-body">
                <AdmissionsPrototype embedded />
            </div>
        </div>
    );
}
